import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

// Logs a per-mount activity event. Idempotent within React strict-mode by
// using a sessionStorage flag keyed on (user_id + surface + minute) so the
// log isn't spammed by HMR or repeated navigations.

export function useLogSurfaceVisit(surface: string, platform?: string) {
  const { user } = useAuth();
  useEffect(() => {
    if (!user?.id) return;
    const minuteBucket = Math.floor(Date.now() / 60_000);
    const key = `activity_${user.id}_${surface}_${platform ?? ''}_${minuteBucket}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch {
      // private mode; insert anyway
    }
    supabase
      .from('user_activity_events')
      .insert({
        user_id: user.id,
        event_type: 'surface_view',
        surface,
        platform: platform ?? null,
      })
      .then(({ error }) => {
        if (error) console.warn('activity log failed:', error.message);
      });
  }, [user?.id, surface, platform]);
}
